<template>
  <div>
    <div class="position-relative">
      <!-- shape Hero -->
      <section class="section-shaped my-0">
        <div class="shape shape-style-1 shape-dark shape-skew">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </div>
        <div class="container shape-container d-flex align-items-center">
          <div class="col px-0">
            <div class="row justify-content-center align-items-center">
              <div class="col-lg-10 text-center">
                <img src="img/brand/brand-logo.png" style="width: 600px" class="img-fluid" />
                <p class="lead text-white">The soul of IT.</p>
                <div class="btn-wrapper"></div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
    <section class="section section-lg pt-lg-0 mt--300">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-12">
            <div class="row row-grid">
              <div class="col-lg-4">
                <card class="border-0" hover shadow body-classes="py-5">
                  <icon
                    name="ni ni-caps-small"
                    type="primary"
                    rounded
                    class="mb-4 bg-gradient-primary"
                    color="white"
                    shadow
                  >
                  </icon>
                  <h6 class="text-primary text-uppercase">What we do</h6>
                  <p class="description mt-3">
                    Custom solutions, cloud-based software, web development. Software
                    development according to customer specifications. You name it we make
                    it!
                  </p>
                  <p class="description mt-3"></p>
                  <div>
                    <badge type="primary" rounded>development</badge>
                    <badge type="primary" rounded>API</badge>
                    <badge type="primary" rounded>Integrations</badge>
                  </div>
                  <base-button type="primary" class="mt-4 bg-gradient-primary">
                    <a href="#/services" class="text-white"> Learn more </a>
                  </base-button>
                </card>
              </div>

              <div class="col-lg-4">
                <card class="border-0" hover shadow body-classes="py-5">
                  <icon
                    name="ni ni-app"
                    type="dark"
                    rounded
                    class="mb-4 bg-gradient-primary"
                    color="white"
                    shadow
                  >
                  </icon>
                  <h6 class="text-primary text-uppercase">Technologies we use</h6>
                  <p class="description mt-3">
                    Developers and teams matched to the technologies you need. We provide
                    programming services using high-level languages (e.g. JavaScript, C#,
                    PHP)
                  </p>
                  <div>
                    <badge type="primary" rounded>JavaScript</badge>
                    <badge type="primary" rounded>PHP</badge>
                    <badge type="primary" rounded>c#</badge>
                    <badge type="primary" rounded>AWS</badge>
                  </div>
                  <base-button
                    type="primary"
                    class="mt-4 bg-gradient-primary"
                    @click="scrollToElement3({ behavior: 'smooth' })"
                  >
                    Learn more
                  </base-button>
                </card>
              </div>
              <div class="col-lg-4">
                <card class="border-0" hover shadow body-classes="py-5">
                  <icon
                    name="ni ni-single-02"
                    type="dark"
                    rounded
                    class="mb-4 bg-gradient-primary"
                    color="white"
                    shadow
                  >
                  </icon>
                  <h6 class="text-primary text-uppercase">Our team</h6>
                  <p class="description mt-3">
                    Take advantage of our self-managing dev teams, ready to take care of
                    your IT project. Let us surprise you with our high standards and
                    dedication!
                  </p>
                  <div>
                    <badge type="primary" rounded>Team</badge>
                    <badge type="primary" rounded>solutions</badge>
                    <badge type="primary" rounded>End-to-end</badge>
                  </div>
                  <base-button type="primary" class="mt-4 bg-gradient-primary"
                    ><a href="#/about-us" class="text-white"> Learn more </a>
                  </base-button>
                </card>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="section section-lg Technologies">
      <div class="container">
        <div class="row justify-content-center text-center">
          <div class="col-lg-8">
            <h2 class="display-3">Technologies we use</h2>
            <p class="lead text-muted">
              We’re ready to deliver, providing the level of support that’s right for your
              business.
            </p>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6 col-lg-3 mb-5 mb-lg-0">
            <div class="px-4">
              <a href="https://nodejs.org/en/" target="_blank">
                <img
                  v-lazy="'img/node.png'"
                  class="rounded-circle img-center img-fluid shadow shadow-lg--hover"
                  style="width: 150px"
                />
              </a>
            </div>
          </div>

          <div class="col-md-6 col-lg-3 mb-5 mb-lg-0">
            <div class="px-4">
              <a href="https://aws.amazon.com/" target="_blank">
                <img
                  v-lazy="'img/aws.png'"
                  class="rounded-circle img-center img-fluid shadow shadow-lg--hover"
                  style="width: 150px"
                />
              </a>
            </div>
          </div>
          <div class="col-md-6 col-lg-3 mb-5 mb-lg-0">
            <div class="px-4">
              <a href="https://www.javascript.com/" target="_blank">
                <img
                  v-lazy="'img/javascript.png'"
                  class="rounded-circle img-center img-fluid shadow shadow-lg--hover"
                  style="width: 150px"
                />
              </a>
            </div>
          </div>
          <div class="col-md-6 col-lg-3 mb-5 mb-lg-0">
            <div class="px-4">
              <a href="https://docs.microsoft.com/en-us/dotnet/csharp/" target="_blank">
                <img
                  v-lazy="'img/csharp.png'"
                  class="rounded-circle img-center img-fluid shadow shadow-lg--hover"
                  style="width: 150px"
                />
              </a>
            </div>
          </div>
        </div>
        <p></p>
        <p></p>
        <div class="row">
          <div class="col-md-6 col-lg-3 mb-5 mb-lg-0">
            <div class="px-4">
              <a href="https://vuejs.org/" target="_blank">
                <img
                  v-lazy="'img/vue.png'"
                  class="rounded-circle img-center img-fluid shadow shadow-lg--hover"
                  style="width: 150px"
                />
              </a>
            </div>
          </div>
          <div class="col-md-6 col-lg-3 mb-5 mb-lg-0">
            <div class="px-4">
              <a href="https://www.docker.com/" target="_blank">
                <img
                  v-lazy="'img/docker.png'"
                  class="rounded-circle img-center img-fluid shadow shadow-lg--hover"
                  style="width: 150px"
                />
              </a>
            </div>
          </div>
          <div class="col-md-6 col-lg-3 mb-5 mb-lg-0">
            <div class="px-4">
              <a href="https://www.mongodb.com/" target="_blank">
                <img
                  v-lazy="'img/mongo.png'"
                  class="rounded-circle img-center img-fluid shadow shadow-lg--hover"
                  style="width: 150px"
                />
              </a>
            </div>
          </div>
          <div class="col-md-6 col-lg-3 mb-5 mb-lg-0">
            <div class="px-4">
              <a href="https://www.php.net/" target="_blank">
                <img
                  v-lazy="'img/php.png'"
                  class="rounded-circle img-center img-fluid shadow shadow-lg--hover"
                  style="width: 150px"
                />
              </a>
            </div>
          </div>
        </div>
        <p></p>
        <div class="row">
          <div class="col-md-6 col-lg-3 mb-5 mb-lg-0">
            <div class="px-4">
              <a href="https://laravel.com/" target="_blank">
                <img
                  v-lazy="'img/laravel.png'"
                  class="rounded-circle img-center img-fluid shadow shadow-lg--hover"
                  style="width: 150px"
                />
              </a>
            </div>
          </div>
          <div class="col-md-6 col-lg-3 mb-5 mb-lg-0">
            <div class="px-4">
              <a href="https://graphql.org/" target="_blank">
                <img
                  v-lazy="'img/graphql.png'"
                  class="rounded-circle img-center img-fluid shadow shadow-lg--hover"
                  style="width: 150px"
                />
              </a>
            </div>
          </div>
          <div class="col-md-6 col-lg-3 mb-5 mb-lg-0">
            <div class="px-4">
              <a href="https://www.typescriptlang.org/" target="_blank">
                <img
                  v-lazy="'img/ts.png'"
                  class="rounded-circle img-center img-fluid shadow shadow-lg--hover"
                  style="width: 150px"
                />
              </a>
            </div>
          </div>
          <div class="col-md-6 col-lg-3 mb-5 mb-lg-0">
            <div class="px-4">
              <a href="https://www.elastic.co/" target="_blank">
                <img
                  v-lazy="'img/elastic.png'"
                  class="rounded-circle img-center img-fluid shadow shadow-lg--hover"
                  style="width: 150px"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="section-sm section-shaped my-0 overflow-hidden">
      <div class="shape shape-style-1 shape-dark shape-skew">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
      <div class="container pb-300">
        <div class="row text-center justify-content-center">
          <div class="col-lg-10">
            <h2 class="display-3 text-white">Let’s talk!</h2>
            <p class="lead text-white">Fill the form and we'll contact you!</p>
          </div>
        </div>
      </div>
    </section>
    <section class="section section-sm pt-lg-0 section-contact-us">
      <div class="container">
        <div class="row justify-content-center mt--300">
          <div class="col-lg-8">
            <card gradient="secondary" shadow body-classes="p-lg-5">
              <h4 class="mb-1">Want to contact us?</h4>
              <p class="mt-0">Ask your questions.</p>
              <base-input class="mt-5" alternative addon-left-icon="ni ni-user-run">
                <textarea
                  class="form-control form-control-alternative"
                  name="name"
                  rows="1"
                  cols="80"
                  placeholder="Your name"
                  v-model="name"
                ></textarea>
              </base-input>
              <base-input alternative addon-left-icon="ni ni-email-83">
                <textarea
                  class="form-control form-control-alternative"
                  name="name"
                  rows="1"
                  cols="80"
                  placeholder="Email address"
                  v-model="email"
                ></textarea>
              </base-input>
              <base-input class="mb-4">
                <textarea
                  class="form-control form-control-alternative"
                  name="name"
                  rows="4"
                  cols="80"
                  placeholder="Type a message..."
                  v-model="message"
                ></textarea>
              </base-input>
              <base-button
                type="secondary"
                round
                block
                size="lg"
                @click="sendMail(message, email, name)"
              >
                Send Message
              </base-button>
            </card>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Carousel from "./components/Carousel.vue";
import AWS from "aws-sdk";
import "dotenv/config";
export default {
  name: "home",
  components: { Carousel },
  data: function () {
    return {
      message: "",
      name: "",
      email: "",
    };
  },
  methods: {
    scrollToElement(options) {
      const transcriptionSection = this.$el.getElementsByClassName(
        "section section section-shaped my-0 overflow-hidden"
      )[0];
      if (transcriptionSection) {
        transcriptionSection.scrollIntoView(options);
      }
    },
    scrollToElement1(options1) {
      const matcherSection = this.$el.getElementsByClassName(
        "section section section-shaped my-0 overflow-hidden matcher"
      )[0];
      if (matcherSection) {
        matcherSection.scrollIntoView(options1);
      }
    },
    scrollToElement2(options2) {
      const teamSection = this.$el.getElementsByClassName("section section-sm TEAM")[0];
      if (teamSection) {
        teamSection.scrollIntoView(options2);
      }
    },
    scrollToElement3(options3) {
      const teamSection = this.$el.getElementsByClassName(
        "section section-lg Technologies"
      )[0];
      if (teamSection) {
        teamSection.scrollIntoView(options3);
      }
    },
    scrollToProducts(options4) {
      const teamSection = this.$el.getElementsByClassName(
        "section section section-shaped my-0 overflow-hidden PRODUCTS"
      )[0];
      if (teamSection) {
        teamSection.scrollIntoView(options4);
      }
    },
    sendMail(msg, email, name) {
      if (msg === "" && name === "") {
        window.alert("Fill the form");
        return;
      }
      if (!String(email).includes("@")) {
        window.alert("Invalid e-mail address");
        return;
      }
      AWS.config.update({
        region: process.env.VUE_APP_AWS_REGION,
        accessKeyId: process.env.VUE_APP_AWS_ACCESS_KEY_ID,
        secretAccessKey: process.env.VUE_APP_AWS_SECRET_ACCESS_KEY,
      });
      // Create publish parameters
      var params = {
        Message: `Name: ${name} \nEmail: ${email} \nMessage: ${msg}`,
        TopicArn: "arn:aws:sns:us-east-1:207301203591:SagacaEmail",
      };

      // Create promise and SNS service object
      var publishTextPromise = new AWS.SNS({ apiVersion: "latest" })
        .publish(params)
        .promise();

      // Handle promise's fulfilled/rejected states
      publishTextPromise
        .then(function (data) {
          window.alert("Message sent");
        })
        .catch(function (err) {
          console.error(err, err.stack);
          window.alert("Error while trying to send a message");
        });
      this.message = "";
      this.name = "";
      this.email = "";
    },
  },
};
</script>
